import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ProductsType } from './ProductsType/ProductsType';
import { ProductsFeed } from './ProductsFeed/ProductsFeed';
import { Reseller } from '../HomePage/Reseller/Reseller'
import { useUser } from '../../context/UserContext';

export const ProductsPage = () => {
  const { user } = useUser();
  const location = useLocation();
  const { searchQuery, filters, fuzzyEnabled, showAll } = location.state || {};
  const [selectedType, setSelectedType] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    countries: [],
    ratings: [],
    types: []
  });
  
  // Determine the user type (buyer or seller) based on the user context
  const userType = user?.company?.type_of_business === 'brand' ? 'buyer' : 'seller';

  // Set initial filters if coming from search
  useEffect(() => {
    if (location.state) {
      // Apply the search query and other filters
      const newFilters = { ...selectedFilters };
      
      // If showAll is true, we don't apply any filters
      if (!showAll) {
        // Update filters based on search query
        if (searchQuery) {
          newFilters.searchQuery = searchQuery;
        }
        
        // Apply location filter if present
        if (filters?.location) {
          newFilters.countries = [filters.location];
        }
        
        // Apply category filter if present
        if (filters?.category) {
          setSelectedType(filters.category);
        }
      }
      
      setSelectedFilters(newFilters);
    }
  }, [location.state]);

  const handleTypeSelect = (type) => {
    setSelectedType(type);
  };
  
  const handleSelectedFilters = (filters) => {
    setSelectedFilters(filters)
  }
  
  return (
    <>
      <div className="ProductsPage__header">
        {searchQuery && !showAll && (
          <div className="ProductsPage__search-info">
            <h2>Search Results: {searchQuery}</h2>
          </div>
        )}
        {showAll && (
          <div className="ProductsPage__search-info">
            <h2>All Products</h2>
          </div>
        )}
      </div>
      
      <ProductsType
        onSelectType={handleTypeSelect}
        selectedType={selectedType}
        onSelectFilters={handleSelectedFilters}
        selectedFilters={selectedFilters}
      />
      <ProductsFeed
        selectedType={selectedType}
        selectedFilters={selectedFilters}
        showAll={showAll}
      />
      <Reseller selected={userType} />
    </>
  )
}

export default ProductsPage;